import { Controller } from 'stimulus'

export default class extends Controller {
  static values = { characterSize: Number, spaceBetweenItems: Number, hiddenClass: String }
  static targets = ['container', 'truncatedCount']

  connect() {
    this.truncate()
  }

  truncate() {
    this.spaceAvailable = this.containerTarget.clientWidth
    this.truncatedItemsCount = 0

    for (let index = 0; index < this.numberOfItems() - 1; index++) {
      if (this.spaceAvailableShowingItem(index) < 0) {
        this.hideItemAt(index)
        this.truncatedItemsCount += 1
      } else {
        this.showItemAt(index)
      }
      this.spaceAvailable -= this.itemWidthAt(index)
    }

    this.showTruncatedItemsCount()
  }

  hideItemAt(index) {
    this.containerTarget.children[index].classList.add(this.hiddenClass())
  }

  showItemAt(index) {
    this.containerTarget.children[index].classList.remove(this.hiddenClass())
  }

  spaceAvailableShowingItem(index) {
    return this.spaceAvailable - this.itemWidthAt(index) - this.counterWidth()
  }

  itemWidthAt(index) {
    return this.containerTarget.children[index].offsetWidth + this.spaceBetweenItemsValue
  }

  showTruncatedItemsCount() {
    if (this.hasTruncatedCountTarget) {
      if (this.truncatedItemsCount <= 0) { this.truncatedCountTarget.classList.add(this.hiddenClass()) }

      this.truncatedCountTarget.innerHTML = `+${this.truncatedItemsCount}`
    }
  }

  hiddenClass() {
    return this.hiddenClassValue || 'hidden'
  }

  counterWidth() {
    if (!this.hasTruncatedCountTarget) return 0
    const numberOfHiddingItems = this.numberOfItems() - this.truncatedItemsCount - 1
    const counterWithoutContentWidth = this.truncatedCountTarget.offsetWidth + this.spaceBetweenItemsValue

    // The characterSizeValue does not represent the width of a character. This is just an approximation
    const counterContentWidth = numberOfHiddingItems.toString().length * this.characterSizeValue
    return counterWithoutContentWidth + counterContentWidth
  }

  numberOfItems() {
    return this.containerTarget.childElementCount
  }
}
